import { FETCH_COMMENTS } from '@/actions/actionTypes';
import { fetchCommentShopping, addCommentShopping } from '@/domains/firestore/comment';
import { Comment } from '@/domains/firestore/comment';
import { AppDispatch } from '@/store/configureStore';

/**
 * Action Creator
 */
export const innerFetchComments = (commentList: Comment[]) => ({
  type: FETCH_COMMENTS,
  payload: {
    commentList
  }
});

/**
 * Action
 */
export const fetchComments = (postId: string) => async (dispatch: AppDispatch) => {
  const commentList = await fetchCommentShopping(postId);
  dispatch(innerFetchComments(commentList));
};

export const addComment = ({
  postId,
  userId,
  message
}: {
  postId: string;
  userId: string;
  message: string;
}) => async (dispatch: AppDispatch) => {
  await addCommentShopping({ postId, userId, message });
  const commentList = await fetchCommentShopping(postId);
  dispatch(innerFetchComments(commentList));
};
